// Paging for the TV columns: a TV is not scrolled by anyone, so cards that do
// not fit are shown page by page, rotating automatically.

export const ROTATE_MS = 12000;

// How many cards fit in a column of `availablePx` height (at least 1).
export function cardsPerPage(availablePx, cardPx = 84) {
  return Math.max(1, Math.floor(availablePx / cardPx));
}

// Items of `page` (0-based; wraps around) and the page count.
export function pageOf(items, perPage, page) {
  const pageCount = Math.max(1, Math.ceil(items.length / perPage));
  const current = ((page % pageCount) + pageCount) % pageCount;
  return {
    items: items.slice(current * perPage, current * perPage + perPage),
    page: current,
    pageCount,
  };
}

// Owner 2026-10-07: the shop TV may hang vertically. Grid shape and cards per
// page for `kolom` columns on a `lebar` × `tinggi` screen:
// - landscape: all columns side by side (as before);
// - portrait: 4 columns -> 2 × 2, 3 columns (POS TV) -> 3 rows.
export const TV_HEADER_PX = 140;   // logo + clock + gaps
export const TV_KOLOM_CHROME_PX = 110; // column title + page footer + padding
export function tataLetakTv(lebar, tinggi, kolom, cardPx = 84) {
  const potret = tinggi > lebar;
  const kolomGrid = potret ? (kolom >= 4 ? 2 : 1) : kolom;
  const baris = Math.ceil(kolom / kolomGrid);
  const tinggiKartu = (tinggi - TV_HEADER_PX) / baris - TV_KOLOM_CHROME_PX;
  return { potret, kolomGrid, baris, perPage: cardsPerPage(tinggiKartu, cardPx) };
}
